import i18n from 'i18next';

// Texto traducido para un error de la API. El servidor responde en un solo
// idioma (y hoy sin `code` en la mayoria de errores), asi que el panel no
// muestra nunca `data.error` tal cual: traduce por `code` si hay clave
// `apiErrors.codes.<code>`, y si no cae a un texto generico traducido.
//
//   err        error de axios (o cualquier Error)
//   t          funcion t() del componente
//   fallbackKey clave i18n del mensaje especifico de la pantalla
export function apiErrorMessage(err, t, fallbackKey = 'errors.generic') {
  const res = err?.response;
  // axios con peticion enviada y sin respuesta: red caida, CORS, timeout.
  if (!res) return err?.request ? t('errors.network') : t(fallbackKey);
  return apiErrorFromData(res.data, t, fallbackKey, res.status);
}

// Igual, partiendo del cuerpo JSON (flujos con fetch, donde no hay err.response).
export function apiErrorFromData(data, t, fallbackKey = 'errors.generic', status) {
  const code = data && typeof data === 'object' ? data.code : undefined;
  // minScore/score: los 422 password_below_policy los llevan en el mensaje ({{minScore}}, {{score}}).
  if (code && i18n.exists(`apiErrors.codes.${code}`)) {
    return t(`apiErrors.codes.${code}`, { minScore: data.minScore, score: data.score });
  }
  if (status === 429) return t('errors.rateLimited');
  if (status === 413) return t('errors.tooLarge');
  if (status >= 500) return t('errors.serverError');
  return t(fallbackKey);
}
